import angular = require("angular");
import TPL = require("templates");

export class BannerDirective {

  template = TPL.commonDirectives.banner;
  scope = {
    params: "=params"
  };
  link;

  constructor() {
    this.link = (scope, el, attrs) => {
        scope.vm = {
          getSrc: () => {
            if (!scope.params.src) { return null;}

            return {'background-image':'url(' + scope.params.src + ')'};
          }
        };
    }
  }


  static factory() {
    return () => new BannerDirective();
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/banner.ts
 **/